import { useEffect } from 'react'
import { useNavigate, useParams } from '@/router/navigation'
import { resumeEnrollment } from '@/api/enrollment-api'
import { useEnrollmentStore } from '@/stores'

export function ResumePage() {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()
  const setEnrollmentId = useEnrollmentStore(state => state.setEnrollmentId)
  const setSessionToken = useEnrollmentStore(state => state.setSessionToken)
  const setCurrentStep = useEnrollmentStore(state => state.setCurrentStep)
  const setResumedEnrollment = useEnrollmentStore(state => state.setResumedEnrollment)

  useEffect(() => {
    if (!token) {
      navigate('/sponsored-enroll', {
        replace: true,
        state: { sponsoredEnrollPath: '/self-enroll' }
      })
      return
    }

    const run = async () => {
      let redirectedSessionToken = ''

      try {
        const resumeData = await resumeEnrollment(token)
        const enrollment = resumeData?.enrollment

        if (enrollment) {
          setResumedEnrollment(enrollment)
          if (typeof enrollment.id === 'number') {
            setEnrollmentId(enrollment.id)
          }
          if (enrollment.sessionToken) {
            setSessionToken(enrollment.sessionToken)
            redirectedSessionToken = enrollment.sessionToken
          }
          if (typeof enrollment.currentStep === 'number') {
            setCurrentStep(enrollment.currentStep)
          }
        }

      } catch { }

      const target = redirectedSessionToken
        ? `/sponsored-enroll?sessionToken=${encodeURIComponent(redirectedSessionToken)}`
        : '/sponsored-enroll'

      navigate(target, {
        replace: true,
        state: { sponsoredEnrollPath: '/self-enroll' }
      })
    }

    run()
  }, [token, navigate, setCurrentStep, setEnrollmentId, setResumedEnrollment, setSessionToken])

  return null
}
